import axios from "src/lib/axios";

export const getSellerProfile = () => axios.get("/sellers/profile");

//seller find all admin
export const getSellerListAdmin = ({
  keyword = null,
  page = null,
  page_size = null,
  status = "all",
  order_case = "desc",
}) => {
  return axios.get(`/sellers/admin`, {
    params: {
      keyword: keyword,
      page: page,
      page_size: page_size,
      status: status,
      order_case: order_case,
    },
  });
};
export const getSellerDetail = (_id) => axios.get(`/sellers/profile/${_id}`);
export const getSellerByUserId = (userId) => {
  return axios.get(`/sellers/user/${userId}`);
};
export const rejectUpdateSeller = (info) =>
  axios.patch("/sellers/reject", info);
//approve seller page
export const approveUpdateSeller = (info) => {
  return axios.patch("/sellers/approve", info);
};
export const updateSellerProfile = (profile) =>
  axios.patch("/sellers", profile);

export const updateSellerPaytype = (info) => {
  return axios.patch(`/sellers/pay-type`, info);
};

export const updateSellerListHome = (data) =>
  axios.patch(`/sellers/home`, data);

export const updateSellerMedia = async (sellerId, data) => {
  const { data: response } = await axios.patch(
    `/sellers/${sellerId}/media`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const updateSellerDelivery = (data) => {
  return axios.patch(`/sellers/delivery-types`, data);
};

export const updateSellerByAdmin = async (sellerId, data) => {
  const { data: response } = await axios.patch(`/sellers/${sellerId}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
